import React from 'react'
import { Body } from '@tecsinapse-org/react-login'
import { Button, Hint, Input, Loading } from '@tecsinapse/cortex-react'
import { LiaEnvelope } from 'react-icons/lia'
import { Select } from '@/core/components/select'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import usePreLogin from '@/modules/pre-login/hooks'
import {
  keyExtractor,
  labelExtractor
} from '@/modules/pre-login/utils/functions'

const Index = () => {
  const { onSubmit, register, realmsWatcher, field, formState } = usePreLogin()

  return (
    <Body.Content>
      <Body.Title>
        <Trans>Bem-vindo ao Portal</Trans>
      </Body.Title>
      <Body.Subtitle>
        <Trans>Insira seu e-mail para prosseguir com o login no sistema</Trans>
      </Body.Subtitle>
      <form className='flex flex-col gap-4 mt-2' onSubmit={onSubmit}>
        <Input.Face>
          <Input.Left>
            <LiaEnvelope className='text-secondary-medium text-deca mt-1' />
          </Input.Left>
          <Input.Box
            {...register('email')}
            required
            type='email'
            label='Email'
            disabled={(realmsWatcher ?? []).length > 0}
          />
        </Input.Face>
        {formState.errors.email ? (
          <Hint variants={{ intent: 'error' }}>
            {formState.errors.email.message}
          </Hint>
        ) : null}
        {(realmsWatcher ?? []).length > 1 ? (
          <Select
            label={t`Selecione o cliente`}
            options={realmsWatcher ?? []}
            keyExtractor={keyExtractor}
            labelExtractor={labelExtractor}
            isMultiSelect={false}
            value={field.value}
            onSelect={e => field.onChange(e)}
          />
        ) : null}
        <Button disabled={formState.isSubmitting || !formState.isValid}>
          {formState.isSubmitting ? (
            <div className='flex gap-2 '>
              <Loading />{' '}
              <p>
                <Trans>Processando</Trans>
              </p>
            </div>
          ) : (
            <p>
              <Trans>Prosseguir</Trans>
            </p>
          )}
        </Button>
      </form>
    </Body.Content>
  )
}

export default Index
